import { render, staticRenderFns } from "./selectMapPos.vue?vue&type=template&id=6b4621f2&scoped=true"
import script from "./selectMapPos.vue?vue&type=script&lang=js"
export * from "./selectMapPos.vue?vue&type=script&lang=js"
import style0 from "./selectMapPos.vue?vue&type=style&index=0&id=6b4621f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4621f2",
  null
  
)

export default component.exports